import NLS                  from "Dashboard/Core/NLS";
import Store                from "Dashboard/Core/Store";
import DateTime             from "Dashboard/Utils/DateTime";
import Utils                from "Dashboard/Utils/Utils";
import { ErrorLog }         from "Utils/API";



// The initial State
const initialState = {
    loading   : true,
    error     : false,
    edition   : 0,
    canCreate : false,
    canEdit   : false,
    canFilter : false,
    canImport : false,
    canExport : false,
    list      : [],
    total     : 0,
    elem      : {},
    filters   : {
        search   : "",
        fromDate : "",
        toDate   : "",
    },
    sort      : {
        orderBy  : "updatedTime",
        orderAsc : 0,
        page     : 0,
        amount   : 50,
    },
};



// The Actions
const actions = {
    /**
     * Starts the Loader
     * @param {Function} dispatch
     * @returns {Void}
     */
    startLoader(dispatch) {
        dispatch({ type : "ERROR_LOG_LOADING" });
    },

    /**
     * Fetches the Error Logs
     * @param {Function} dispatch
     * @param {Object=}  filters
     * @param {Object=}  sort
     * @returns {Promise}
     */
    async fetchList(dispatch, filters = {}, sort = {}) {
        const data   = await ErrorLog.getAll({ ...filters, ...sort });
        data.filters = filters;
        data.sort    = sort;
        dispatch({ type : "ERROR_LOG_LIST", data });
    },

    /**
     * Fetches a single Error Log
     * @param {Function} dispatch
     * @param {Number}   logID
     * @returns {Promise}
     */
    async fetchElem(dispatch, logID) {
        const data = await ErrorLog.getOne({ logID });
        dispatch({ type : "ERROR_LOG_ELEM", data });
    },

    /**
     * Resolves an Error Log
     * @param {Function}          dispatch
     * @param {(Number[]|Number)} logID
     * @returns {Promise}
     */
    resolveElem(dispatch, logID) {
        const logIDs = JSON.stringify(Utils.toArray(logID));
        return ErrorLog.markResolved({ logIDs });
    },

    /**
     * Deletes one or more Error Logs
     * @param {Function}          dispatch
     * @param {(Number[]|Number)} logID
     * @returns {Promise}
     */
    deleteElem(dispatch, logID) {
        const logIDs = JSON.stringify(Utils.toArray(logID));
        return ErrorLog.delete({ logIDs });
    },
};



/**
 * Parses a single Element
 * @param {Object} elem
 * @returns {Object}
 */
function parseElem(elem) {
    elem.updatedTimeText = DateTime.formatDate(elem.updatedTime, "dashesSeconds");
    elem.resolvedColor   = elem.isResolved ? "green"      : "red";
    elem.resolvedClass   = elem.isResolved ? "text-green" : "";
    elem.resolvedText    = elem.isResolved ? NLS.get("ERRORS_LOG_RESOLVED") : "-";
    elem.amountErrorCode = `${elem.amount} x ${elem.errorText} (${elem.errorCode})`;
    elem.errorCode       = `${elem.errorText} (${elem.errorCode})`;
    elem.fileLine        = `${elem.file} (${elem.line})`;
    return elem;
}

/**
 * The Reducer
 * @param {Object=} state
 * @param {Object=} action
 * @returns {Object}
 */
const reducer = (state = initialState, action = {}) => {
    if (Utils.hasError(action, "ERROR_LOG_LIST", "ERROR_LOG_ELEM")) {
        return { ...state, loading : false, error : true };
    }

    switch (action.type) {
    case "ERROR_LOG_LOADING":
        return {
            ...state,
            loading   : true,
        };

    case "ERROR_LOG_LIST":
        return {
            ...state,
            loading   : false,
            error     : false,
            canCreate : action.data.canCreate,
            canEdit   : action.data.canEdit,
            canFilter : action.data.canFilter,
            canImport : action.data.canImport,
            canExport : action.data.canExport,
            list      : Utils.parseList(action.data.list, parseElem),
            total     : action.data.total,
            filters   : action.data.filters,
            sort      : action.data.sort,
        };

    case "ERROR_LOG_ELEM":
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            elem      : parseElem(action.data.elem),
        };

    default:
        return state;
    }
};




// The public API
export default Store.createSlice(initialState, actions, reducer);
